import { onlyLettersAndNumbers } from './validators';

export const maskCpf = (cpf: string) => {
  const num = cpf.replace(/[^\d]/g, '');
  const length = num.length;

  if (length <= 6) {
    cpf = num.replace(/(\d{3})(\d{1,3})/g, '$1.$2');
  } else if (length <= 9) {
    cpf = num.replace(/(\d{3})(\d{3})(\d{1,3})/g, '$1.$2.$3');
  } else if (length <= 11) {
    cpf = num.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, '$1.$2.$3-$4');
  } else if (length >= 12) {
    cpf = cpf.substr(0, 14);
  }
  return cpf;
};

export const removeMask = (value: string) => {
  const removeChar = value.replace(/(\.|\/|-)/g, '');
  return removeChar.replace('(', '').replace(')', '');
};

export const maskPhone = (phone: string) => {
  const num = phone.replace(/[^\d]/g, '');
  const length = num.length;
  if (length <= 6) {
    phone = num.replace(/(\d{2})(\d{1,6})/g, '($1) $2');
  } else if (length <= 10) {
    phone = num.replace(/(\d{2})(\d{4})(\d{1,4})/g, '($1) $2-$3');
  } else if (length <= 11) {
    phone = num.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');
  } else if (length <= 15) {
    phone = phone.substr(0, 14);
  }
  return phone;
};

export const maskCep = (cep: string) => {
  const num = cep.replace(/[^\d]/g, '');
  const length = num.length;
  if (length <= 8) {
    cep = num.replace(/(\d{5})(\d{1,3})/g, '$1-$2');
  } else if (length >= 9) {
    cep = cep.substr(0, 9);
  }
  return cep;
};

export const maskStringDate = (date: string) => {
  const num = date.replace(/[^\d]/g, '');
  const { length } = num;

  if (length <= 4) {
    date = num.replace(/(\d{2})(\d{1,2})/g, '$1/$2');
  } else if (length <= 9) {
    date = num.replace(/(\d{2})(\d{2})(\d{1,4})/g, '$1/$2/$3');
  }

  return date;
};

export const maskDateStringIso = (dateStringIso: string) => {
  if (Date.parse(dateStringIso)) {
    const dateSplited = dateStringIso.split('-');
    return dateSplited[2] + '/' + dateSplited[1] + '/' + dateSplited[0];
  }
};

export const maskPassport = (passport: string): string => {
  const validPassport = onlyLettersAndNumbers(passport);
  if (validPassport.length >= 10) {
    return validPassport.substr(0, 10);
  }
  return validPassport;
};

export const maskScheduleCode = (code: string): string => {
  let scheduleCode = onlyLettersAndNumbers(code).toUpperCase();
  if (scheduleCode.length >= 6) {
    scheduleCode = scheduleCode.substr(0, 6);
  }
  scheduleCode = scheduleCode.replace(/([A-Z0-9]{3})([A-Z0-9]{1,3})/g, '$1-$2');
  return scheduleCode;
};

export function accentsTidy(s: string) {
  let r = s.toLowerCase();
  r = r.replace(new RegExp(/\s/g), '');
  r = r.replace(new RegExp(/[àáâãäå]/g), 'a');
  r = r.replace(new RegExp(/æ/g), 'ae');
  r = r.replace(new RegExp(/ç/g), 'c');
  r = r.replace(new RegExp(/[èéêë]/g), 'e');
  r = r.replace(new RegExp(/[ìíîï]/g), 'i');
  r = r.replace(new RegExp(/ñ/g), 'n');
  r = r.replace(new RegExp(/[òóôõö]/g), 'o');
  r = r.replace(new RegExp(/œ/g), 'oe');
  r = r.replace(new RegExp(/[ùúûü]/g), 'u');
  r = r.replace(new RegExp(/[ýÿ]/g), 'y');
  r = r.replace(new RegExp(/\W/g), '');
  return r;
}

export const removerAccents = (word: string) => {
  return word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
